import { render, staticRenderFns } from "./PaymentPlanFrequencies.vue?vue&type=template&id=99296784"
import script from "./PaymentPlanFrequencies.vue?vue&type=script&lang=js"
export * from "./PaymentPlanFrequencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports